import React, { useState } from "react";
import { Link } from "react-router-dom";

function ProductItem({ product }) {
  const [isHovered, setIsHovered] = useState(false);

  // We already get numeric ID from ProductGrid
  const numericId = product.id;
  const handle = product.handle;

  // Prefer SEO-friendly handle URL, fallback to legacy /product/:id
  const productUrl = handle
    ? `/products/${handle}`
    : `/product/${numericId}`;

  return (
    <div
      className="px-4 flex flex-col items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={productUrl}>
        <div className="relative w-full h-72 md:h-64 lg:h-52 overflow-hidden">
          <img
            src={product.imageSrc}
            alt={product.title}
            className={`w-full h-full object-cover transition-all duration-500 ${
              isHovered ? "opacity-25" : "opacity-100"
            }`}
          />
          {/* Hover effect */}
          {isHovered && (
            <div
              className="absolute inset-0 flex items-center justify-center bg-opacity-50"
              style={{
                backdropFilter: "blur(1px)",
                WebkitBackdropFilter: "blur(1px)",
              }}
            >
              <span className="text-md italic text-center">
                {product.title} 
              </span>
            </div>
          )}
        </div>
      </Link>
    </div>
  );
}

export default ProductItem;
